import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Digitalização, redução de equipe e novas ferramentas de abertura de ticket",
    correct: false,
  },
  {
    option:
      "b) Ganho de eficiência, detecção rápida de anomalias e análise qualificada de incidentes",
    correct: true,
  },
  {
    option: "c) Redução de custos, aumento de equipe e governança",
    correct: false,
  },
  {
    option:
      "d) Abertura rápida de incidentes, análise ágil e aumento da receita",
    correct: false,
  },
  {
    option:
      "e) Redução de receita, tempo de resposta lento e aumento de equipe",
    correct: false,
  },
];

export default function Question10(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question10: {
          title:
            "Quais os principais benefícios da aplicação de IA generativa em cibersegurança?",
          option: option.option,
          correct: option.correct,
          order: 10,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quais os principais benefícios da aplicação de IA generativa em cibersegurança?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
